<template>
    <div v-if="content">
        <div v-if="['message', 'error'].indexOf(content.type) >= 0">
            <span v-if="content.type === 'message'" class="alert alert-success d-block">{{ content.message }}</span>
            <span v-if="content.type === 'error'" class="alert alert-warning d-block">{{ content.message }}</span>
        </div>
        <b-card-body v-else>
            <!-- <pulse-loader v-if="loading && showLoading" :loading="loading" /> -->
            <div v-if="relationship === 'BelongsToMany'">
                <multi-select-component
                    :key="type"
                    :type="content.type"
                    :parent="parent"
                    :selectedItems="content.data"
                    :timestamp="timestamp"
                    :schema="content.schema"
                    :updateBatch="updateBatch"
                    :onInitialized="onInitialized"
                    ></multi-select-component>
            </div>
            <div v-else>
                <item-component
                    v-if="contentType === 'item'"
                    :timestamp="timestamp"
                    :section="section"
                    :type="content.type"
                    :bindKeys="true"

                    :id="content.id"
                    :key="content.type + content.id"
                    :parent="parent"
                    :attributes="content.attributes"
                    :meta="content.meta"
                    :schema="content.schema.attributes"
                    :references="content.schema.refs"
                    :resourceParams="resourceParams"

                    :changeUrl="changeUrl"
                    :changeSection="changeSection"
                    :changeQuery="changeQuery"

                    :haltFetch="haltFetch"
                    :addNotification="addNotification"
                    :commitQueue="commitQueue"
                    :pushQueue="pushQueue"

                    :createData="createData"
                    :updateData="updateData"
                    :deleteData="deleteData"

                    :onInitialized="onInitialized"
                    :onCreated="onCreated"
                    :onChanged="onChanged"
                    :onUpdated="onUpdated"
                    :onDeleted="onDeleted"
                    ></item-component>
                <collection-component
                    v-if="contentType === 'collection'"
                    :key="type"
                    :content="content"
                    :parent="parent"
                    :resourceParams="resourceParams"
                    :timestamp="timestamp"
                    :query="query"
                    :section="section"
                    :selected="selected"

                    :createData="createData"
                    :updateBatch="updateBatch"
                    :deleteData="deleteData"

                    :changeUrl="changeUrl"
                    :changeSection="changeSection"
                    :changeQuery="changeQuery"

                    :addNotification="addNotification"

                    :onCreating="onCreating"
                    :onSelected="onSelected"
                    :onInitialized="onInitialized"
                    ></collection-component>
            </div>
        </b-card-body>
    </div>
</template>

<script>
import Vue from 'vue';
import V from 'voca';
import _ from 'lodash';

import * as VueGoogleMaps from 'vue2-google-maps';
Vue.use(VueGoogleMaps, {
    load: {
        key: window.env.GOOGLE_MAP_KEY,
        libraries: "places" // necessary for places input
    }
});

import PulseLoader from 'vue-spinner/src/PulseLoader';
import CollectionComponent from './CollectionComponent';
import ItemComponent from './ItemComponent';
import MultiSelectComponent from './helpers/MultiSelectComponent';

export default {

    props: [
        'type', 'content', 'contentType', 'parent',
        'relationship', 'timestamp', 'section', 'selected',
        'loading', 'showLoading', 'query', 'resourceParams',
        'changeUrl', 'changeQuery', 'changeSection', 'haltFetch',
        'updateData', 'deleteData', 'createData', 'updateBatch',
        'addNotification', 'commitQueue', 'pushQueue',
    ],

    components: {
        PulseLoader,
        CollectionComponent,
        ItemComponent,
        MultiSelectComponent,
    },

    watch: {

    },

    computed: {
        contentData() {
            return this.content.data;
        },
        attributes() {
            return Object.keys(this.content.data)
                .filter(key => key !== 'id')
                .map(key => {
                    const value = this.content.data[key];
                    return { key, value }
                })
        },
    },

    mounted() {
        console.log('Component mounted.')
    },

    methods: {
        sortAsc(fieldName) {
            return (item1, item2) => item1.attributes[fieldName] <= item2.attributes[fieldName];
        },
        sortDesc(fieldName) {
            return (item1, item2) => item1.attributes[fieldName] >= item2.attributes[fieldName];
        },
        titleCase(val) {
            return V.titleCase(val);
        },
        onCreating(type, schema) {
            this.changeSection('create');
            // emit an event so that the main component can prepare the form
            this.$emit('content::creating', {
                type, schema,
                attributes: {}, meta: {},
            });
        },
        onCreated(type, data) {
            this.$emit('content::created', {
                type, data
            });
        },
        onChanged(payload) {
            this.$emit('content::changed', payload);
        },
        onUpdated(type, data) {
            console.log(type);
            this.$emit('content::updated', {
                type, data
            });
        },
        onDeleted(type, data) {
            this.$emit('content::deleted', {
                type, data
            });
        },
        onInitialized(type, name, config) {
            this.$emit('content::initialized', {
                type, name, config,
            });
        },
        onSelected(type, data) {
            this.$emit('content::selected', {
                type, data,
            });
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/ContentViewComponent.vue